import request from '#/utils/request';
import { withFmsActor } from '#/api/fmsMgmt/fmsActorConfig';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/**
 * POST `/fms/payment-requests/{id}/submission`。
 * 契約 body 可為 `{}`；若帶樂觀鎖則傳 `{ updatedAt }`。
 */
export async function submitPaymentRequest(id, payload = {}) {
  const { data: raw } = await request.post(
    `/fms/payment-requests/${id}/submission`,
    keysToSnake(payload),
    withFmsActor(),
  );
  return parseVer4DetailResponse(raw);
}
